define('apps/classrooms/views/pdf-utils/generate-label-pdf-download',[
    "vendor/jspdf/jspdf",
    "vendor/jszip/jszip",
    "vendor/jszip-utils/jszip-utils",
    "vendor/jsfilesaver/jsfilesaver",
    "apps/classrooms/views/pdf-utils/common",
    "apps/classrooms/views/pdf-utils/pdf-mixin"
],
/*eslint strict: [0, "function"]*/
function(
    jspdf,
    JSZip,
    jsZipUtils,
    jsFilesaver,
    pdfCommonUtils,
    pdfMixin
) {
    /**
     * Takes a list of printable students and creates a PDF with
     *  a QR code and student details. For each PDF page, we display a 10 rows containing
     *  3 columns. After we have compiled all of the pages, create a PDF, and automatically prompt
     *  download. This layout follows the following Address Label sticker paper,
     *  Avery 5160 Address Labels 1" x 2-5/8".
     */
    function buildLabelPDF(targetStudents, isZip, zipFile, folderName) {
        var pdf = new jsPDF({ // eslint-disable-line new-cap
            "orientation": 'p',
            "unit": 'in',
            "format": 'letter',
        });

        var columnCount = 3;

        var rowHeight = 1.025,
            columnWidth = 2.8,
            qrWidth = .9;

        var studentChunks = pdfCommonUtils.generateChunks(targetStudents || this.model.get('printStudents'), 30),
            totalChunks = studentChunks.length,
            domain = this.model.get('currentDomain');

        pdf.setFontSize(6.5);

        for (var sc = 0; sc < totalChunks; sc++) {
            var studentIndex = 0;
            var leftMargin = .05;
            var topMargin = .11;

            // get the number of rows on this page.
            var rows = pdfCommonUtils.generateChunks(studentChunks[sc], 3);

            for (var i = 0; i < rows.length; i++) {
                // adjust first row for avery sticker label buffer on
                //  physical paper.
                if (i > 0) {
                    topMargin += .019;
                }

                for (var c = 0; c < columnCount; c++) {
                    var student = studentChunks[sc][studentIndex];

                    if (!student) {
                        break;
                    }

                    var colOffset = columnWidth * c + leftMargin;
                    var colHeightOffset = rowHeight * i + topMargin;
                    var textColumnOffset = colOffset + qrWidth;

                    if (c > 0) {
                        colOffset += .1 * c;
                    }

                    /**
                     * each cell has a 2 column layout. First cell is
                     *  the QR Code. Second cell are details about the student.
                     * */

                    // add QR PNG
                    pdf.addImage(
                        student.qrAuth.qr_png_b64,
                        'PNG',
                        colOffset,
                        colHeightOffset + topMargin,
                        qrWidth,
                        qrWidth,
                        student.id
                    );

                    // default second column in cell. List out all of the student
                    //  details and lets iterate through.
                    var studentNameLabel = this.getStudentLabelName(student),
                        textRows = [
                        'Discovery Education',
                        studentNameLabel || ' ', // empty name so we dont have to alter spacing.
                        student.qrAuth.localExpiryWithLabel,
                        domain,
                    ];

                    var textRowHeight = rowHeight / 4;

                    for (var t = 0; t < textRows.length; t++) {
                        var textHeightOffset = colHeightOffset + topMargin + (textRowHeight * t);

                        // app name needs to be offset.
                        var textOffset = (c === 0) ? .075 : .075 * 1.75 * c;

                        pdf.text(
                            textRows[t],
                            textColumnOffset + textOffset,
                            textHeightOffset + .075,
                            'left'
                        );
                    }

                    // increment to next student.
                    studentIndex += 1;
                }

                if (isZip) {
                    zipFile.file(
                        folderName + '.pdf',
                        pdf.output('blob')
                    );
                }
            }

            if (sc < totalChunks - 1) {
                pdf.addPage();
            }
        }

        return isZip ? zipFile : pdf;
    };

    return function(isZip, model, forcePDFFormat) {
        this.model = model;
        this.buildLayout = buildLabelPDF;

        $.each(Object.keys(pdfMixin), _.bind(function(_, key) {
            this[key] = pdfMixin[key];
        }, this))

        return this.buildTargetTypePDF(isZip, forcePDFFormat);
    };
});

